import { useParams } from 'react-router-dom'
import { CompareLayout } from '@/components/compare/CompareLayout'
import { DEMO_COMPARE_BATCH_ID } from '@/types/compare'

export function ComparePage() {
  const { batchId = DEMO_COMPARE_BATCH_ID } = useParams()

  return <CompareLayout batchId={batchId} />
}
